
export default {
  props: {
    backgroundPrimary: {
      type: String,
      default: "#ffffff",
    },
    backgroundSecondary: {
      type: String,
      default: "#ffffff",
    },
    imgSide: {
      type: String,
      required: true,
    },
    imageName: String,
    altText: String,
    ctaButtonTitle: String,
    displayCtaButton: {
     type: Boolean,
     default: true
    },
    containerClasses: String
  },
  computed: {
    flipImage: function () {
      return this.imgSide === "right";
    },
    cssVars: function () {
      return {
        "--background-primary-color": this.backgroundPrimary
          ? this.backgroundPrimary
          : "#ffffff",
        "--background-secondary-color": this.backgroundSecondary
          ? this.backgroundSecondary
          : "#ffffff",
        "--background-direction":
          this.imgSide === "to right" ? "to left" : "to right",
      };
    },
    imagePaths: function () {
      const mainDir = "/assets/imgs/";
      return {
        mobile: `${mainDir}${this.imageName.substring(
          0,
          this.imageName.lastIndexOf(".")
        )}-mobile${this.imageName.substring(this.imageName.lastIndexOf("."))}`,
        desktop: `${mainDir}${this.imageName.substring(
          0,
          this.imageName.lastIndexOf(".")
        )}${this.imageName.substring(this.imageName.lastIndexOf("."))}`,
      };
    },
  },
};
